export const production = process.env.NEXT_PUBLIC_ENV === "production"; //Determina si estas en produccion o no
export const urlDev = production ? "" : ""; //Para configurar si quieres rutas relativas en las imagenes y algunos link, para trabajar en local sobre todo
//https://dev-cronica.cms-medios.com
//https://www.cronica.com.ar

//para mostrar el icono de video, galeria y audio
export function getMultiIcon(video, gallery, audio) {
  if (video) {
    return (
      <div className="multi-icon">
        <svg className="video-icon" viewBox="0 0 16 18.353">
          <use xlinkHref="#video-svg"></use>
        </svg>
      </div>
    );
  } else if (gallery) {
    return (
      <div className="multi-icon">
        <svg className="gallery-icon" viewBox="0 0 16 16">
          <use xlinkHref="#gallery-svg"></use>
        </svg>
      </div>
    );
  } else if (audio) {
    return (
      <div className="multi-icon">
        <svg className="audio-icon" viewBox="0 0 17.984 17.525">
          <use xlinkHref="#audio-svg"></use>
        </svg>
      </div>
    );
  } else {
    return null;
  }
}
////
export const urlTemp = production
  ? "https://www.cronica.com.ar"
  : "https://cronica.cms-medios.com"; //asigna una url segun si estas en DEV o PROD

export const nofoto = "/arte/cronicaReact/nofoto.png"; // Para usar cuando no haya una imagen de preview

export const autorNofoto = "/arte/cronicaReact/autor-nofoto.png"; // Para usar cuando no haya una imagen para autores.

//Muestra el autor que no sea Cronica
export function showAuthor(author) {
  if (author && author !== "Crónica") {
    return (
      <p className="autor">
        Por <span>{author}</span>
      </p>
    );
  } else {
    return null;
  }
}
////
//Muestra el autor que no sea Depo
export function showAuthorDepo(author) {
  if (author && author !== "Depo") {
    return (
      <p className="autor">
        Por <span>{author}</span>
      </p>
    );
  } else {
    return null;
  }
}
////
//Muestra el autor que no sea Bae Negocios
export function showAuthorBAE(author) {
  if (author && author !== "BAE Negocios") {
    return (
      <p className="autor">
        Por <span>{author}</span>
      </p>
    );
  } else {
    return null;
  }
}
////
//Muestra el autor que no sea Diario Show
export function showAuthorDiarioShow(author) {
  if (author && author !== "Diario Show") {
    return (
      <p className="autor">
        Por <span>{author}</span>
      </p>
    );
  } else {
    return null;
  }
}
////
//Funcion para mostrar Volanta
export function showUppertitle(uppertitle) {
  if (uppertitle) {
    return <span className="inner-volanta">{uppertitle}</span>;
  } else {
    return null;
  }
}
////
//Funcion para no mostrar preview
export function showPreview(title, wI, hI) {
  return (
    <div className="sin-foto">
      <source
        media="(min-width:1024px)"
        width={720}
        height={406}
        srcSet="/arte/cronicaReact/nofoto.png"
        loading="lazy"
      />
      <img
        src="/arte/cronicaReact/nofoto.png"
        width={wI}
        height={hI}
        alt={title}
        title={title}
        loading="lazy"
      />
    </div>
  );
}
////
//Muestra si hay Tag en un articulo.
export function showTagArticle(tagarticle) {
  if (tagarticle && tagarticle !== "no_mostrar") {
    return <div className="kicker-atencion">{tagarticle}</div>;
  } else {
    return null;
  }
}
////
export function showAny(any) {
  if (any) {
    return any[0].name;
  } else {
    return null;
  }
}
//Arma los lag para las url, le saca las tildes y caracteres especiales
export function urlTags(tag) {
  function replaceAll(str, find, replace) {
    return str?.replace(new RegExp(find, "g"), replace);
  }
  let tag2 = replaceAll(typeof tag === "string" ? tag : "", " ", "-");
  let Tag = tag2
    ?.replace("á", "a")
    .replace("é", "e")
    .replace("í", "i")
    .replace("ó", "o")
    .replace("ú", "u")
    .replace("ñ", "n");
  let encodeTag = encodeURI(Tag, "UTF-8");
  //let lowerEncode = encodeTag.toLocaleLowerCase()
  return encodeTag;
}
////
export function replaceAll(str, find, replace) {
  return str?.replace(new RegExp(find, "g"), replace);
}
//Conversor de tiempo para el schema.org
export function timeConverterHour(UNIX_timestamp) {
  let a = new Date(UNIX_timestamp);
  
  // Ajustar la zona horaria a Argentina (UTC-3)
  a.setUTCHours(a.getUTCHours() - 3);
  
  let year = a.getFullYear();
  let months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
  ];
  let month = months[a.getUTCMonth()];
  let dateData = a.getUTCDate();
  let date = dateData < 10 ? `0${dateData}` : dateData;
  let hourData = a.getUTCHours();
  let hour = hourData < 10 ? `0${hourData}` : hourData;
  let minData = a.getUTCMinutes();
  let min = minData < 10 ? `0${minData}` : minData;
  let sData = a.getUTCSeconds();
  let s = sData < 10 ? `0${sData}` : sData;
  let time = `${year}-${month}-${date}T${hour}:${min}:${s}-03:00`;
  return time;
}
export function timeGetHour(UNIX_timestamp){
  let a = new Date(UNIX_timestamp);
  return `${a.getHours()}`
}
////

/**
 * Conversor de Slug para el path que la API acepta.
 */
export function convertSlugToApiPath(slug) {
  const reg = new RegExp("([0-9]{4})([0-9]{2})([0-9]{2})-([0-9]{4,6})", "g");
  const match = reg.exec(slug);
  if (!match) {
    return false;
  }

  const [_, year, month, day, newsId] = match;
  return `/contenidos/${year}/${month}/${day}/noticia_${newsId}.html`;
}

/**
 * Check if exist duplicated articles between two arrays of articles, if is a duplicate, then is
 * deleted from the first array.
 * @param {*} firstBlock First array of articles
 * @param {*} secondBlock  Second array of articles
 * @returns The first array without duplications
 */
export const checkDuplicateArticle = (firstBlock, secondBlock) => {
  if (Array.isArray(firstBlock) && Array.isArray(secondBlock)) {
    firstBlock.forEach((elementFirst, indexFirst) => {
      secondBlock.forEach((elementSecond, indexSecond) => {
        if (
          elementFirst?.main?.title?.home === elementSecond?.main?.title?.home
        ) {
          firstBlock.splice(indexFirst, 1);
        }
      });
    });
    return firstBlock;
  }
};
